import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
require('./plugins');

//ARCHIVO CSS GLOBAL
import "@/assets/css/main.css"

//FONT AWESOME
import '@fortawesome/fontawesome-free/css/all.css'

//AOS - ANIMACIONES
import AOS from 'aos'
import 'aos/dist/aos.css'

// Import Vue FilePond
import vueFilePond from 'vue-filepond';
import 'filepond/dist/filepond.min.css';
import './registerServiceWorker'



/**
 * Filtro para mostrar contenido en formato de moneda nacional (MXN).
 * @param {(string|number)} value   El valor a convertir a moneda nacional.
 */
Vue.filter('currency', (value) => {
  if (!value || (typeof value != "string" && typeof value != "number")) return ''
  if (typeof value === 'string') 
    value = Number(value);

  // return new Intl.NumberFormat("es-MX").format(value)
  // return value.toLocaleString('es-MX');
  return value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
})

/**
 * Filtro para mostrar una fecha en formato YYYY-mm-dd.
 * @param {(string|number)} value   El valor a convertir a moneda nacional.
 */
Vue.filter('date', (value) => {
  if (!value) return ''
  const array = value.split('-');

  return `${array[2]}-${array[1]}-${array[0]}`;
})


Vue.config.productionTip = false
new Vue({
  // FUNCIÓN QUE INICIALIZA LAS ANIMACIONES DEL SITIO
  created () {
    AOS.init()
  },
  router,
  store,
  vuetify,
  iconfont: 'fa',
  render: h => h(App)
}).$mount('#app')
